import MicroModal from 'micromodal';
var validate = require("validate.js");

let closeModalArr = Array(document.querySelectorAll('.c-modal__close'))[0];
closeModalArr.forEach(anchor=>{
	anchor.addEventListener('click', (e)=>{
		e.preventDefault();
		let parent = anchor.closest('.c-modal');
		MicroModal.close(parent.id);
		// document.getElementById('body').classList.remove('blocked');
	});
});

let toggleHeaderMenu = document.querySelector('[data-id="mobile-menu-toggle"]');
if (toggleHeaderMenu) {
	toggleHeaderMenu.addEventListener('click', ()=>{
		let header = toggleHeaderMenu.closest('.c-header__mobile');
		if (header.classList.contains('open')) {
			header.classList.remove('open');
		}else{
			header.classList.add('open');
		}
	});
}



let checkAllCheckbox = document.getElementById('get-info-check-all');
let getInfoChecked = 0;
let getInfoCheckboxesArr = Array(document.querySelectorAll('[name="get-info-check"]'))[0];
if(checkAllCheckbox){
	checkAllCheckbox.addEventListener('change', ()=>{
		getInfoCheckboxesArr.forEach(item =>{
			if (checkAllCheckbox.checked) {
				if (!item.checked) {
					item.checked = true;
					getInfoChecked++;
				}
			}else{
				item.checked = false;
				getInfoChecked--;
			}
		});
		if (getInfoChecked>0) {
			enableGetInfoCheckBoxBtn(true);
		}else{
			enableGetInfoCheckBoxBtn(false);
		}
	});
	getInfoCheckboxesArr.forEach(item =>{
		item.addEventListener('change', ()=>{
			if (item.checked) {
				getInfoChecked++;
				if (getInfoChecked == getInfoCheckboxesArr.length) {
					checkAllCheckbox.checked = true;	
				}
			}else{
				getInfoChecked--;
				checkAllCheckbox.checked = false;
			}
	
	
			if (getInfoChecked>0) {
				enableGetInfoCheckBoxBtn(true);
			}else{
				enableGetInfoCheckBoxBtn(false);
			}
		});
	})
	function enableGetInfoCheckBoxBtn(enable){
		let btns = Array(checkAllCheckbox.closest('.info-screen').querySelectorAll('[data-id="get-info-screen-1-btn"]'))[0];
		if (enable) {
			btns.forEach(btn=>{btn.disabled = false;})
		}else{
			btns.forEach(btn=>{btn.disabled = true;})
		}
	}
}


let getInfoScreen1Btn = Array(document.querySelectorAll('[data-id="get-info-screen-1-btn"]'))[0];
getInfoScreen1Btn.forEach(item=>{
	item.addEventListener('click', (e)=>{
		e.preventDefault();
		let container = item.closest('.p-get-info');
		let container_items = container.querySelectorAll('.info-screen');
		for (let index = 0; index < container_items.length; index++) {
			if(container_items[index].contains(item)){
				container_items[index].classList.remove('active');
				container_items[index+1].classList.add('active');
				window.scrollTo(0,0);
			}
		}
	});
});




let getInfoScreen2Return = Array(document.querySelectorAll('[data-id="get-info-screen-2-return-btn"]'))[0];
getInfoScreen2Return.forEach(item=>{
	item.addEventListener('click', (e)=>{
		e.preventDefault();
		let container = item.closest('.p-get-info');
		let container_items = container.querySelectorAll('.info-screen');
		for (let index = 0; index < container_items.length; index++) {
			if(container_items[index].contains(item)){
				container_items[index].classList.remove('active');
				container_items[index-1].classList.add('active');
				window.scrollTo(0,0);
			}
		}
	});	
});





if(document.getElementById('modal-cookies')){
	
	let cookiesModalOpenConfigBtn = document.querySelector('[data-id="cookies-modal-open-config-btn"]');
	if (cookiesModalOpenConfigBtn) {
		cookiesModalOpenConfigBtn.addEventListener('click', ()=>{
			let container = cookiesModalOpenConfigBtn.closest('.c-modal__content');
			if (container.classList.contains('open')) {
				container.classList.remove('open');
			}else{
				container.classList.add('open');
			}
		});
	}

	let cookiesModalReturnBtn = document.querySelector('[data-id="cookies-modal-return-btn"]');
	if (cookiesModalReturnBtn) {
		cookiesModalReturnBtn.addEventListener('click', ()=>{
			let container = cookiesModalReturnBtn.closest('.c-modal__content');
			if (container.classList.contains('open')) {
				container.classList.remove('open');
			}else{
				container.classList.add('open');
			}
		});
	}

	let preferenceCookiesSelection = Array(document.querySelectorAll('[name="preferences-cookies-radio"]'))[0]
	preferenceCookiesSelection.forEach(radio=>{
		radio.addEventListener('change', ()=>{
			checkCookiesAcceptBtn();
		});
	});

	let analyticsCookiesSelection = Array(document.querySelectorAll('[name="analytics-cookies-radio"]'))[0]
	analyticsCookiesSelection.forEach(radio=>{
		radio.addEventListener('change', ()=>{
			checkCookiesAcceptBtn();
		});
	});

	let publicityCookiesSelection = Array(document.querySelectorAll('[name="publicity-cookies-radio"]'))[0]
	publicityCookiesSelection.forEach(radio=>{
		radio.addEventListener('change', ()=>{
			checkCookiesAcceptBtn();
		});
	});

	let cookiesAcceptConfigBtn = document.querySelector('[data-id="cookies-modal-accept-config-btn"]');
	if (cookiesAcceptConfigBtn) {
		cookiesAcceptConfigBtn.addEventListener('click', ()=>{
			MicroModal.close('modal-cookies');
			// console.log('Closing cookies')
			// document.getElementById('body').classList.remove('blocked');
		});
	}

	function checkCookiesAcceptBtn(){
		if (
			Array.prototype.slice.call(preferenceCookiesSelection).filter(item => item.checked === true).length > 0 &&
			Array.prototype.slice.call(analyticsCookiesSelection).filter(item => item.checked === true).length > 0 &&
			Array.prototype.slice.call(publicityCookiesSelection).filter(item => item.checked === true).length > 0
		) {
			cookiesAcceptConfigBtn.disabled = false;
		}else{
			cookiesAcceptConfigBtn.disabled = true;
		}
	}


	setTimeout(()=>{
		MicroModal.show('modal-cookies');
		// document.getElementById('body').classList.add('blocked');
	}, 1000)


}




MicroModal.init({
	// onShow: () =>{
	// 	console.log('open');
	// 	document.getElementById('body').classList.add('blocked');
	// },
	// onClose: () => {
	// 	console.log('close');
	// 	document.getElementById('body').classList.remove('blocked');
	// },
	awaitOpenAnimation: true,
  	awaitCloseAnimation: true
});